import React from 'react';
import { Menu, Icon, Button } from 'antd';
import GuruLogo from 'img/png/logo-white.png';
import { GoogleLogout } from 'react-google-login';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './SiderLayout.less';

const { localStorage } = window;

function SiderLayout(props) {
  const { location } = props;
  const routeKeys = {
    '/': '1',
    'oferta-general': '2',
    'vuelo-sencillo': '3',
    'vuelo-redondo': '4',
    'vuelo-mas-hotel': '5',
    'oferta-hotel': '6',
    'hero-tool': '7',
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  // Variable to get the url
  const locationPath = location.pathname.split('/');
  const locationPathKey = locationPath[1] ? routeKeys[locationPath[1]] : '1';
  return (
    <div className="sider-layout-container">
      <div>
        <img className="guru-logo" src={GuruLogo} alt="app-store" />
      </div>
      <Menu theme="dark" mode="inline" defaultSelectedKeys={[locationPathKey]} selectedKeys={[locationPathKey]} className="menu">
        <div>
          <div className="sider-subtitle">Acceso Rápido</div>
        </div>
        <Menu.Item key="1" className="custom-item">
          <Link to="/">
            <Button type="link" className="sider-button-link" icon="home">
              Dashboard
            </Button>
          </Link>
        </Menu.Item>
        <Menu.Item key="2" className="custom-item">
          <Link to="/oferta-general/">
            <Button type="link" className="sider-button-link" icon="tag">
              Oferta General
            </Button>
          </Link>
        </Menu.Item>
        <Menu.Item key="3" className="custom-item">
          <Link to="/vuelo-sencillo/">
            <Button type="link" className="sider-button-link" icon="arrow-right">
              Vuelo Sencillo
            </Button>
          </Link>
          <Icon type="arrow-right" />
        </Menu.Item>
        <Menu.Item key="4" className="custom-item">
          <Link to="/vuelo-redondo/">
            <Button type="link" className="sider-button-link" icon="swap">
              Vuelo Redondo
            </Button>
          </Link>
        </Menu.Item>
        <Menu.Item key="5" className="custom-item">
          <Link to="/vuelo-mas-hotel/">
            <Button type="link" className="sider-button-link" icon="shop">
              Vuelo + Hotel
            </Button>
          </Link>
        </Menu.Item>
        <Menu.Item key="6" className="custom-item">
          <Link to="/oferta-hotel/">
            <Button type="link" className="sider-button-link" icon="environment">
              Oferta Hotel
            </Button>
          </Link>
        </Menu.Item>
        <div>
          <div className="sider-subtitle">Herramientas</div>
        </div>
        <Menu.Item key="7" className="custom-item">
          <Link to="/hero-tool/">
            <Button type="link" className="sider-button-link" icon="shop">
              Hero Slider
            </Button>
          </Link>
        </Menu.Item>
        <div>
          <div className="sider-subtitle">Cuenta</div>
        </div>
        <Menu.Item key="8" className="custom-item">
          <Link to="/ajustes/">
            <Button type="link" className="sider-button-link" icon="setting">
              Ajustes
            </Button>
          </Link>
        </Menu.Item>
      </Menu>
      <div className="logout-div">
        <GoogleLogout
          clientId={process.env.REACT_APP_GOOGLE_AUTH}
          onLogoutSuccess={() => {
            handleLogout();
          }}
          render={(renderProps) => (
            <div className="bottom-div">
              <Button onClick={renderProps.onClick} type="link" icon="poweroff">
                Log Out
              </Button>
            </div>
          )}
        />
      </div>
    </div>
  );
}

SiderLayout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};

const SiderLayoutWithRouter = withRouter(SiderLayout);
export default SiderLayoutWithRouter;
